import { render, staticRenderFns } from "./TerraIndigena.vue?vue&type=template&id=ba4affc2&lang=pug"
import script from "./TerraIndigena.vue?vue&type=script&lang=js"
export * from "./TerraIndigena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports